import { useEffect, useState } from "react";
import olVectorSource from "ol/source/Vector";
import olFeature from "ol/Feature";
import { CensusMapLocation } from "../interractions/CensusMapLocation";
import { GbCensusSelectedStyle } from "./LayerStyle";
import { Vector } from "../../../../reactOL/layers/Vector";

interface GbCensusSelectedBoundaryLayerProps {
  selectedLocation: CensusMapLocation | null;
}

const GbCensusSelectedBoundaryLayer = ({
  selectedLocation,
}: GbCensusSelectedBoundaryLayerProps) => {
  const [source] = useState(() => new olVectorSource());

  useEffect(() => {
    source.clear();
    if (selectedLocation?.geometry) {
      source.addFeature(new olFeature({ geometry: selectedLocation.geometry }));
    }
  }, [selectedLocation, source]);

  return (
    <Vector
      name="GbCensusSelectedBoundary"
      source={source}
      style={GbCensusSelectedStyle}
      zIndex={8001}
    />
  );
};

export default GbCensusSelectedBoundaryLayer;
